import { mapBrFromString, makeClassName } from '@/utils';

function emojiOnlyAndMaxLen3(str = '') {
	const replacedStr = String(str).replace(/\p{Extended_Pictographic}/gu, '');

	if (replacedStr.length === 0) {
		return str.length > 0 && str.length < 7;
	}

	return false;
}

export default function Text({ text, block }) {
	const isEmojiOnly = emojiOnlyAndMaxLen3(text);

	const id = block ? `block-title-${block.typeName}-${block.id}` : null;

	return (
		<p className={makeClassName('bubble-text', isEmojiOnly && 'chat-icon')}>
			<legend id={id}>{mapBrFromString(text)}</legend>
		</p>
	);
}
